import React,{useState,useEffect} from 'react'
import './Activity.css'
import { useDispatch } from 'react-redux';
import files from "./../../../../assets/templates/audit_template/Activity.xlsx"
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import mainicon from "../../../../assets/register_assets/inputMatix/CTC_Master/mainicon.png"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import { uploadActivityFile,multiDeleteActivityFile,getActivity,updateActivityById,deleteActivityById } from '../../../../services/global_redux/globale_actions/ActRuleActivity.action';
function Activity({ setLoading, showSnackbar }) {
  
    const [file, setFile] = useState([])
    const [getData, setGetData] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const header = [
        { key: "ruleId", value: "Rule ID" , readOnly:true , icon: null },
        { key: "activityId", value: "Activity ID" , readOnly:true , icon: null },
        { key: "activityName", value: "Activity Name" ,readOnly:true , icon: null},
        { key: "frequency", value: "frequency" , readOnly:true , icon: null},
        { key: "ruleNumber", value: "Rule Number" ,readOnly:true , icon: null},
        { key: "dueDate", value: "Due Date" , icon: null},
        { key: "dueMonth", value: "Due Month" ,icon: null},
        { key: "remainderFrom", value: "Reminder From" ,icon: null},
        { key: "section_id", value: "Section ID" ,icon: null},
        // { key: "status", value: "Status" ,icon: null},
    ];
    
    const [actionChecked, setActionChecked] = useState("");
    
    const fetchdata = async () => {
        try {
            const response = await dispatch(getActivity());
            if (response.data) {
                setGetData(response.data);
            } 
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    }
    useEffect(() => {

        fetchdata();
    }, [dispatch]);
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteActivityById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };

    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadActivityFile(file));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



    const downloadBase64Excel = (contentBase64, filename) => {
        try {
            // Decode base64 to binary
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Create download link
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'activity_failed_rows.xlsx';
            document.body.appendChild(a); // Required for Firefox
            a.click();
            
            // Cleanup
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            
            console.log('Error file downloaded successfully:', filename);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file. Please try again.', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (!file) {
            showSnackbar('Please select a file to upload', 'warning');
            return;
        }
        
        setLoading(true);
        
        try {
            const response = await dispatch(uploadActivityFile(file));
            console.log("Upload activity response:", response);
            
            // ============================================================
            // HANDLE SUCCESS RESPONSE (status 200)
            // ============================================================
            if (response.success === true) {
                const data = response.data; // This is the backend response object
                
                setActionChecked("create");
                // Check if we have the expected response structure
                if (!data) {
                    showSnackbar('Unexpected response format', 'error');
                    setLoading(false);
                    return;
                }
                
                // Extract counts
                const insertedCount = data.inserted_count || 0;
                const failedCount = data.failed_count || 0;
                const totalRows = insertedCount + failedCount;
                
                // CASE 1: Full success (all rows inserted)
                if (insertedCount > 0 && failedCount === 0) {
                    showSnackbar(
                        data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                        'success'
                    );
                    
                    // Refresh the data table
                    fetchdata();
                    setFile(null);
                }
                
                // CASE 2: Partial success (some rows inserted, some failed)
                else if (insertedCount > 0 && failedCount > 0) {
                    showSnackbar(
                        `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                        `${failedCount} record(s) failed. Downloading error file...`,
                        'warning',
                        6000 // Show for 6 seconds
                    );
                    
                    // Download error file
                    if (data.error_file && data.error_file.content_base64) {
                        downloadBase64Excel(
                            data.error_file.content_base64, 
                            data.error_file.filename
                        );
                    } else {
                        console.warn('No error file in response despite failed rows');
                    }
                    
                    // Refresh the data table (to show successfully inserted rows)
                    fetchdata();
                    // Don't clear the file - user might want to fix and re-upload
                }
                
                // CASE 3: Complete failure (all rows failed)
                else if (insertedCount === 0 && failedCount > 0) {
                    showSnackbar(
                        `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                        `Downloading error file with details...`,
                        'error',
                        6000
                    );
                    
                    // Download error file
                    if (data.error_file && data.error_file.content_base64) {
                        downloadBase64Excel(
                            data.error_file.content_base64, 
                            data.error_file.filename
                        );
                    } else {
                        console.warn('No error file in response despite all rows failing');
                        // Fallback: show the message if available
                        if (data.message) {
                            showSnackbar(data.message, 'error', 8000);
                        }
                    }
                }
                
                // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
                else {
                    showSnackbar(
                        data.message || 'Upload completed with unexpected result', 
                        'info'
                    );
                }
                
                setLoading(false);
            }
            
            // ============================================================
            // HANDLE ERROR RESPONSE (non-200 status)
            // ============================================================
            else {
                const errorMsg = response.error || 'Upload failed';
                
                // Handle different error types
                if (typeof errorMsg === 'string') {
                    showSnackbar(errorMsg, 'error');
                } else if (Array.isArray(errorMsg)) {
                    // If backend returns array of errors
                    const displayError = errorMsg.slice(0, 3).join('; ') + 
                        (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                    showSnackbar(displayError, 'error');
                } else if (typeof errorMsg === 'object' && errorMsg.error) {
                    showSnackbar(errorMsg.error, 'error');
                } else {
                    showSnackbar('An error occurred during upload', 'error');
                }
                
                setLoading(false);
            }
            
        } catch (error) {
            // This catches any unexpected errors in the frontend code
            console.error('Upload error:', error);
            showSnackbar('An unexpected error occurred. Please try again.', 'error');
            setLoading(false);
        }
    };


    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteActivityFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }
    
    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            const response = await dispatch(updateActivityById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message.error, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
  return (
    <div className='container-fluid'>
        <ImportFileform
            setFiledata={setFile}
            title={'Activity'}
            filestemp={files}
            handleFileUpload={handleFileUpload}
            File={file}
        />
        <EditableTable
        
        header={header}
        mainIcon={mainicon}
        title={'Activity'}
        data={getData}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {true}
        getDeletePermission = {true}
        // date={date}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        mainIconColor={"#4ad991"}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
            <></>
        }
        />
    </div>
  )
}

export default Activity